import { auth } from '@/services'

const beforeEnter = (to, from, next) => {
  if (auth.getUserAuthData()) {
    next('/')
  } else {
    next()
  }
}

const privateRoute = (config) => {
  return {
    ...config,
    beforeEnter
  }
}

export default privateRoute
